// @owners { team: patients }
import { createSelector } from 'reselect';
import getPrescriptionPricingByID from './getPrescriptionPricingByID';
import { getItemPricingTotal } from './getPricingInfoForPrescription';
import { PRESCRIPTION_PRICING_LABELS } from '~shared/features/pricing/constants';
import { type ReduxStateShared } from '~shared/types';

const getPricingForPrescription = (state: ReduxStateShared, prescriptionID: number) =>
  getPrescriptionPricingByID(state, prescriptionID);

/** True when per-Rx pricing indicates Progyny checkout (native redirect on web). */
export const getIsProgynyPrescription = createSelector(
  [getPricingForPrescription],
  (pricing) => getItemPricingTotal(pricing).reason === PRESCRIPTION_PRICING_LABELS.PROGYNY,
);
